module.exports = __webpack_public_path__ + "static/img/311_TO8_2302.6cd2e48.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/311_TO8_2302.jpg
// module id = PXw3
// module chunks = 0